<script module>
  export const d =
    'm11.4434703 19.4783366-4.32813003 2.3778518c-.58462558.3211902-1.3077194.0863015-1.61507526-.5246386-.12239071-.2432795-.16462471-.5219369-.12016368-.7928326l.82659927-5.036371c.06653927-.4054159-.06208156-.8190878-.34394642-1.1062049l-3.50153072-3.5667778c-.47297203-.4817853-.48264989-1.27302711-.02161611-1.76728803.18358607-.19681729.424139-.32490202.6844184-.36442518l4.83899645-.73479662c.38952767-.05914938.72626136-.3148127.90046343-.68367223l2.16406497-4.58224171c.2923128-.61894992 1.0094254-.87307556 1.6017158-.56760552.2358532.12163978.426757.32113642.5431575.56760552l2.164065 4.58224171c.1742021.36885953.5109358.62452285.9004635.68367223l4.8389964.73479662c.6536313.09925324 1.1065091.73343677 1.0115309 1.41648851-.0378208.2719949-.1603887.5233753-.3487286.7152247l-3.5015307 3.5667778c-.2818649.2871171-.4104857.700789-.3439464 1.1062049l.8265992 5.036371c.1116536.6802918-.3255651 1.3263644-.9765553 1.4430436-.2592277.0464622-.5258826.0023272-.7586836-.1255724l-4.32813-2.3778518c-.3484042-.1914114-.7646299-.1914114-1.113034 0z';
</script>
<script lang="ts">
  type Props = {
    class?: string;
    size?: number | string;
    color?: string;
    outlined?: boolean;
    drawer?: boolean;
    penalty?: boolean;
  };
  const props: Props = $props();
</script>

<svg
  class={props.class ?? 'yellow'}
  class:penalty={props.penalty}
  class:drawer={props.drawer}
  width={props.size ?? '2em'}
  height={props.size ?? '2em'}
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
  fill={props.color}
>
  {#if props.outlined}
    <path class="outlined" stroke-width="2px" {d} />
  {/if}
  <path {d} />
</svg>

<style lang="scss">
  @use 'sass:color';
  @use '~/theme/theme';
  @use '~/theme/themify' as *;

  svg {
    transition: fill 0.25s ease;
    overflow: visible;
  }
  .tile {
    z-index: -1;
    position: absolute;
    top: 0.1em;
    left: 0.1em;
  }
  .yellow {
    fill: theme.$star;
  }
  .drawer path {
    fill: none;
    stroke: currentColor;
    stroke-width: 2px;
  }
  .green {
    fill: theme.$star-bonus;
    .outlined {
      @include themify {
        stroke: themed('star-bonus-border');
      }
    }
  }
  .penalty {
    @include themify {
      fill: themed('star-penalty');
      .outlined {
        stroke: themed('star-penalty-border');
      }
    }
  }
  .grey {
    @include themify {
      fill: themed('star-blank');
      .outlined {
        stroke: themed('star-blank-border');
      }
    }
  }
  .current {
    fill: currentColor;
  }
  .outlined {
    @include themify {
      stroke: themed('star-border');
    }
  }
</style>
